// src/Us.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Us_default = createIcon({
  displayName: "Us",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("path", {
        id: "white",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 1V33H49V1H1Z",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "red",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 1V3.5H49V1H25Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "red_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 10.8333V13.3333H49V10.8333H25Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "red_3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 20.6667V23.1667H49V20.6667L1 20.6667Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "red_4",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 5.91675V8.41675H49V5.91675H25Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "red_5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 15.75V18.25H49V15.75L25 15.75Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "red_6",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 25.5833V28.0833H49V25.5833H1Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "red_7",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 30.5V33H49V30.5H1Z",
        fill: "#FF1A26"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "blue",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 1V18.25H25V1H1Z",
        fill: "#0070B8"
      }),
      /* @__PURE__ */ jsxs("g", {
        id: "Group 3",
        children: [
          /* @__PURE__ */ jsx("path", {
            id: "Star 55",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.00001 4L2.41222 4.30902L2.52448 3.65451L2.04895 3.19098L2.70611 3.09549L3.00001 2.5L3.2939 3.09549L3.95106 3.19098L3.47553 3.65451L3.58779 4.30902L3.00001 4Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_2",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.00001 4L6.41222 4.30902L6.52448 3.65451L6.04895 3.19098L6.70611 3.09549L7.00001 2.5L7.2939 3.09549L7.95106 3.19098L7.47553 3.65451L7.58779 4.30902L7.00001 4Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_3",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 4L10.4122 4.30902L10.5245 3.65451L10.049 3.19098L10.7061 3.09549L11 2.5L11.2939 3.09549L11.9511 3.19098L11.4755 3.65451L11.5878 4.30902L11 4Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_4",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 4L14.4122 4.30902L14.5245 3.65451L14.049 3.19098L14.7061 3.09549L15 2.5L15.2939 3.09549L15.9511 3.19098L15.4755 3.65451L15.5878 4.30902L15 4Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_5",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 4L18.4122 4.30902L18.5245 3.65451L18.049 3.19098L18.7061 3.09549L19 2.5L19.2939 3.09549L19.9511 3.19098L19.4755 3.65451L19.5878 4.30902L19 4Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_6",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 4L18.4122 4.30902L18.5245 3.65451L18.049 3.19098L18.7061 3.09549L19 2.5L19.2939 3.09549L19.9511 3.19098L19.4755 3.65451L19.5878 4.30902L19 4Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_7",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21 7L20.4122 7.30902L20.5245 6.65451L20.049 6.19098L20.7061 6.09549L21 5.5L21.2939 6.09549L21.9511 6.19098L21.4755 6.65451L21.5878 7.30902L21 7Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_8",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.00001 7L4.41222 7.30902L4.52448 6.65451L4.04895 6.19098L4.70611 6.09549L5.00001 5.5L5.2939 6.09549L5.95106 6.19098L5.47553 6.65451L5.58779 7.30902L5.00001 7Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_9",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.00001 7L8.41222 7.30902L8.52448 6.65451L8.04895 6.19098L8.70611 6.09549L9.00001 5.5L9.2939 6.09549L9.95106 6.19098L9.47553 6.65451L9.58779 7.30902L9.00001 7Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_10",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13 7L12.4122 7.30902L12.5245 6.65451L12.049 6.19098L12.7061 6.09549L13 5.5L13.2939 6.09549L13.9511 6.19098L13.4755 6.65451L13.5878 7.30902L13 7Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_11",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17 7L16.4122 7.30902L16.5245 6.65451L16.049 6.19098L16.7061 6.09549L17 5.5L17.2939 6.09549L17.9511 6.19098L17.4755 6.65451L17.5878 7.30902L17 7Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_12",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23 4L22.4122 4.30902L22.5245 3.65451L22.049 3.19098L22.7061 3.09549L23 2.5L23.2939 3.09549L23.9511 3.19098L23.4755 3.65451L23.5878 4.30902L23 4Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_13",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.00001 10L2.41222 10.309L2.52448 9.65451L2.04895 9.19098L2.70611 9.09549L3.00001 8.5L3.2939 9.09549L3.95106 9.19098L3.47553 9.65451L3.58779 10.309L3.00001 10Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_14",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.00001 10L6.41222 10.309L6.52448 9.65451L6.04895 9.19098L6.70611 9.09549L7.00001 8.5L7.2939 9.09549L7.95106 9.19098L7.47553 9.65451L7.58779 10.309L7.00001 10Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_15",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 10L10.4122 10.309L10.5245 9.65451L10.049 9.19098L10.7061 9.09549L11 8.5L11.2939 9.09549L11.9511 9.19098L11.4755 9.65451L11.5878 10.309L11 10Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_16",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 10L14.4122 10.309L14.5245 9.65451L14.049 9.19098L14.7061 9.09549L15 8.5L15.2939 9.09549L15.9511 9.19098L15.4755 9.65451L15.5878 10.309L15 10Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_17",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 10L18.4122 10.309L18.5245 9.65451L18.049 9.19098L18.7061 9.09549L19 8.5L19.2939 9.09549L19.9511 9.19098L19.4755 9.65451L19.5878 10.309L19 10Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_18",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 10L18.4122 10.309L18.5245 9.65451L18.049 9.19098L18.7061 9.09549L19 8.5L19.2939 9.09549L19.9511 9.19098L19.4755 9.65451L19.5878 10.309L19 10Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_19",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21 13L20.4122 13.309L20.5245 12.6545L20.049 12.191L20.7061 12.0955L21 11.5L21.2939 12.0955L21.9511 12.191L21.4755 12.6545L21.5878 13.309L21 13Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_20",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.00001 13L4.41222 13.309L4.52448 12.6545L4.04895 12.191L4.70611 12.0955L5.00001 11.5L5.2939 12.0955L5.95106 12.191L5.47553 12.6545L5.58779 13.309L5.00001 13Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_21",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.00001 13L8.41222 13.309L8.52448 12.6545L8.04895 12.191L8.70611 12.0955L9.00001 11.5L9.2939 12.0955L9.95106 12.191L9.47553 12.6545L9.58779 13.309L9.00001 13Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_22",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13 13L12.4122 13.309L12.5245 12.6545L12.049 12.191L12.7061 12.0955L13 11.5L13.2939 12.0955L13.9511 12.191L13.4755 12.6545L13.5878 13.309L13 13Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_23",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17 13L16.4122 13.309L16.5245 12.6545L16.049 12.191L16.7061 12.0955L17 11.5L17.2939 12.0955L17.9511 12.191L17.4755 12.6545L17.5878 13.309L17 13Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_24",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23 10L22.4122 10.309L22.5245 9.65451L22.049 9.19098L22.7061 9.09549L23 8.5L23.2939 9.09549L23.9511 9.19098L23.4755 9.65451L23.5878 10.309L23 10Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_25",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.00001 16L2.41222 16.309L2.52448 15.6545L2.04895 15.191L2.70611 15.0955L3.00001 14.5L3.2939 15.0955L3.95106 15.191L3.47553 15.6545L3.58779 16.309L3.00001 16Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_26",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.00001 16L6.41222 16.309L6.52448 15.6545L6.04895 15.191L6.70611 15.0955L7.00001 14.5L7.2939 15.0955L7.95106 15.191L7.47553 15.6545L7.58779 16.309L7.00001 16Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_27",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 16L10.4122 16.309L10.5245 15.6545L10.049 15.191L10.7061 15.0955L11 14.5L11.2939 15.0955L11.9511 15.191L11.4755 15.6545L11.5878 16.309L11 16Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_28",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 16L14.4122 16.309L14.5245 15.6545L14.049 15.191L14.7061 15.0955L15 14.5L15.2939 15.0955L15.9511 15.191L15.4755 15.6545L15.5878 16.309L15 16Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_29",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 16L18.4122 16.309L18.5245 15.6545L18.049 15.191L18.7061 15.0955L19 14.5L19.2939 15.0955L19.9511 15.191L19.4755 15.6545L19.5878 16.309L19 16Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_30",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 16L18.4122 16.309L18.5245 15.6545L18.049 15.191L18.7061 15.0955L19 14.5L19.2939 15.0955L19.9511 15.191L19.4755 15.6545L19.5878 16.309L19 16Z",
            fill: "white"
          }),
          /* @__PURE__ */ jsx("path", {
            id: "Star 55_31",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23 16L22.4122 16.309L22.5245 15.6545L22.049 15.191L22.7061 15.0955L23 14.5L23.2939 15.0955L23.9511 15.191L23.4755 15.6545L23.5878 16.309L23 16Z",
            fill: "white"
          })
        ]
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      })
    ]
  })
});

export {
  Us_default
};
